import { ToolbarPosition } from "shared/classroom/toolbar/core";

const storageKeys = {
    toolbarPosition: 'config.toolbar.drawingTools.position',
};

const storage = sessionStorage;

export const getStoredToolbarPosition = () => {
    const toolbarPositionString = storage.getItem(storageKeys.toolbarPosition);
    if (toolbarPositionString == null) {
        return null;
    } else {
        try {
            const { right, bottom } = JSON.parse(toolbarPositionString) as Partial<ToolbarPosition>;
            return typeof right === 'number' && typeof bottom === 'number' ? { right, bottom } : null;
        } catch {
            return null;
        }
    }
};
export const updateStoredToolbarPosition = (position: ToolbarPosition) =>
    storage.setItem(storageKeys.toolbarPosition, JSON.stringify(position));
export const deleteStoredToolbarPosition = () => storage.removeItem(storageKeys.toolbarPosition);
